import { AxiosRequestConfig } from 'axios'
import { CallEffect, PutEffect, SelectEffect } from 'redux-saga/effects'

import { ApiResponse, ErrorData } from '../../interfaces'
import { ILogin } from '../login'

export interface IError extends ErrorData {
  status: number
}

export interface ISendToPayload extends ILogin {
  userId: string
}

export interface ISendToLoginFallbackPayload {
  userId: string
}

export type SendToGeneratorYield =
  | SelectEffect
  | CallEffect<ISendToPayload | ApiResponse<string | ErrorData>>
  | PutEffect<ISendToSuccess | ISendToFail>

export type SendToGeneratorReturn = AxiosRequestConfig | ApiResponse<string | IError>

export const SEND_TO = 'SEND_TO'
export const SEND_TO_LOGIN_FALLBACK = 'SEND_TO_LOGIN_FALLBACK'
export const SEND_TO_SUCCESS = 'SEND_TO_SUCCESS'
export const SEND_TO_FAIL = 'SEND_TO_FAIL'

export interface ISendTo {
  type: typeof SEND_TO
  payload: ISendToPayload
}

export interface ISendToLoginFallback {
  type: typeof SEND_TO_LOGIN_FALLBACK
  payload: ISendToLoginFallbackPayload
}
export interface ISendToSuccess {
  type: typeof SEND_TO_SUCCESS
  payload: string
}

export interface ISendToFail {
  type: typeof SEND_TO_FAIL
  payload: IError
}

export type SendToDispatchTypes = ISendTo | ISendToLoginFallback | ISendToSuccess | ISendToFail
